import { detectFromEnvironment } from './detectContext';

export function DeniedBanner() {
  const result = detectFromEnvironment();
  if (result.context !== 'denied_explain') return null;
  return (
    <div class="tiny-banner error" role="status" aria-live="polite">
      Notifications are off. Re-enable: Settings → Notifications → Park Club.
    </div>
  );
}

